import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ModalHeader from '@/desktop/common/modal/header';

const { requestSetChosenCard } = Mobi2Go.Customer.DataCandyLoyalty;

const MultipleCardsModal = ({
    closeModal,
    setModalIsClosable,
    savedCards,
    chosenCard,
    setChosenCard,
    customerEmail,
}) => {
    const [selectedCard, setSelectedCard] = useState(null);
    const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
    const [isRefreshing, setIsRefreshing] = useState(false);
    const [switchButtonTriggered, setSwitchButtonTriggered] = useState(true);

    const [t] = useTranslation('order.loyalty');

    const className = name =>
        `m2g-customer-loyalty-multiple-cards-modal${name || ''}`;
    const disabledButtonClassName = saveButtonDisabled
        ? 'm2g-button--disabled'
        : '';

    useEffect(() => {
        setModalIsClosable(chosenCard !== null);
        setSaveButtonDisabled(selectedCard === null);

        if (chosenCard) {
            setSelectedCard(chosenCard);
        }

        if (switchButtonTriggered) {
            setSaveButtonDisabled(true);
        }
    }, []);

    useEffect(() => {
        if (selectedCard && !switchButtonTriggered) {
            setSaveButtonDisabled(false);
        }
    }, [selectedCard]);

    const handleSave = async e => {
        e.preventDefault();
        setIsRefreshing(true);

        if (selectedCard) {
            setModalIsClosable(true);
            setSaveButtonDisabled(true);

            await requestSetChosenCard(customerEmail, selectedCard);
            setIsRefreshing(false);
            setChosenCard(selectedCard);
            closeModal();
        }
    };

    return (
        <>
            <ModalHeader
                headerText={t('multiple_cards_title')}
                onClose={closeModal}
            />
            <div className={className('-body m2g-modal-body')}>
                <div className={className('-text')}>
                    {t('multiple_cards_text')}
                </div>
                <hr />
                <form
                    onSubmit={e => handleSave(e)}
                    className={className('-form')}
                >
                    {savedCards.map(card => {
                        return (
                            <div
                                className={className('-saved-card-container')}
                                key={card}
                            >
                                <div className={className('-saved-card')}>
                                    <label
                                        className={className(
                                            `-saved-card-label ${
                                                selectedCard === card
                                                    ? className(
                                                          '-saved-card__selected'
                                                      )
                                                    : ''
                                            }`
                                        )}
                                    >
                                        <input
                                            type="radio"
                                            value={card}
                                            className={className('-card-input')}
                                            checked={selectedCard === card}
                                            onChange={() => {
                                                setSelectedCard(card);
                                                setSwitchButtonTriggered(false);
                                            }}
                                        />
                                        <span
                                            className={className(
                                                '-card-icon m2g-icon m2g-icon--credit-card'
                                            )}
                                        />
                                        {card}
                                    </label>
                                </div>
                                <hr />
                            </div>
                        );
                    })}

                    {isRefreshing && (
                        <div
                            className={className(
                                '-loading-indicator-container'
                            )}
                        >
                            <div
                                className={className(
                                    '-loading-indicator m2g-icon m2g-icon--spinner m2g-icon--small'
                                )}
                            />
                        </div>
                    )}

                    <button
                        type="submit"
                        className={className(
                            `-save-button m2g-button m2g-button--primary ${disabledButtonClassName}`
                        )}
                        disabled={saveButtonDisabled}
                    >
                        {t('customer.details:save')}
                    </button>
                </form>
            </div>
        </>
    );
};

export default MultipleCardsModal;
